export default __webpack_public_path__ + "static/SRUS P255 - Especification Del Producto y Datos Técnicos-d9e489a6843e62a2aeb922e6a0d5dac1.pdf";